'use strict';

(function () {
  'use strict';

  angular.module('msAssessment').controller('AssessmentCtrl', AssessmentCtrl);

  AssessmentCtrl.$inject = ['$rootScope', '$state', '$stateParams', '$sessionStorage', 'wellnessSvc', 'assessmentRouter', 'providerContext', '$window', '$timeout', 'loadingScreenSvc'];

  function AssessmentCtrl($rootScope, $state, $stateParams, $sessionStorage, wellnessSvc, assessmentRouter, providerContext, $window, $timeout, loadingScreenSvc) {
    $rootScope.$state = $state;
    var vm = this;
    vm.isShowDisclamer = false;
    vm.next = _next;
    vm.back = _back;
    vm.goToNextQuestion = goToNextQuestion;
    vm.goToNextStep = goToNextStep;

    _activate();

    function _activate() {
      vm.currentQuestionIndex = $stateParams.question || 1;
      vm.totalQuestion = 0;
      vm.translatePrefix = providerContext.translatePrefix || 'onboarding';
      vm.currentAssessmentOrdinal = parseInt($stateParams.assessment.toString()) || 1;
      //load the applicable assessments and find the one we are currently taking
      wellnessSvc.getAssessments($state.params.types).then(function (data) {
        vm.assessments = _.filter(data, _.identity);
        _setViewData();
        focusAssessmentMain();
      });

      $timeout(function () {
        loadingScreenSvc.removeLoadingScreen();
      }, 1000);
    }

    function _back() {
      vm.currentQuestionIndex--;
      $window.history.back();
      focusAssessmentMain();
    }

    function _setViewData() {
      vm.assessment = vm.assessments[vm.currentAssessmentOrdinal - 1];
      vm.assessment.questions = vm.assessment.questions.sort(function (a, b) {
        return a.positionOrdinal - b.positionOrdinal;
      });
      vm.totalQuestion = vm.totalQuestion + _.flatten(_.map(vm.assessments, 'questions')).length;
      vm.widthPercent = {
        'width': (wellnessSvc.getTotalAnsweredCount() + 1) * 100 / vm.totalQuestion + '%'
      };
    }

    function _next(ans) {
      var currentQuestion = vm.assessment.questions[vm.currentQuestionIndex - 1];

      //send the current answer off to the svc for aggregation
      if (wellnessSvc.addAssessmentAnswer(vm.assessment, currentQuestion.id, ans)) {
        //move to the next assessment in the list, reset questionIndex to 1
        vm.currentAssessmentOrdinal++;
        vm.currentQuestionIndex = 1;
      } else {
        vm.currentQuestionIndex++;
        vm.widthPercent = {
          'width': (wellnessSvc.getTotalAnsweredCount() + 1) * 100 / vm.totalQuestion + '%'
        };
      }

      if (vm.currentAssessmentOrdinal - 1 > 0 && vm.currentQuestionIndex === 1 || wellnessSvc.getTotalAnsweredCount() === vm.totalQuestion || !vm.assessments[vm.currentAssessmentOrdinal - 1]) {
        saveAssessmentResponse([vm.assessment]);
      } else {
        goToNextQuestion();
      }
      focusAssessmentMain();
    }

    function goToNextQuestion() {
      if ($stateParams.redirecturl) {
        $sessionStorage.redirectUrl = $stateParams.redirecturl;
      }
      assessmentRouter.navigateNextQuestion({
        assessment: vm.currentAssessmentOrdinal,
        question: vm.currentQuestionIndex
      });
    }

    function saveAssessmentResponse(assessments) {
      wellnessSvc.saveAssessmentResponses(assessments).then(function (data) {
        if (data && data.requirements && data.requirements.length) {
          $sessionStorage.user = data.response || $sessionStorage.user;
          vm.isShowDisclamer = true;
        } else if (data.response) {
          $sessionStorage.user = data.response || $sessionStorage.user;
          goToNextStep();
        } else {
          //there was no return user or requirement, we should probably error
          assessmentRouter.navigateError({
            message: 'An error occurred while saving your assesssment',
            contact: true
          });
        }
      });
    }

    function goToNextStep() {
      if (wellnessSvc.getTotalAnsweredCount() === vm.totalQuestion || !vm.assessments[vm.currentAssessmentOrdinal - 1]) {
        assessmentRouter.goToNextStep($stateParams);
      } else {
        goToNextQuestion();
      }
    }

    // WCAG helper that sets focus to section#assessment-main
    function focusAssessmentMain() {
      $timeout(function () {
        var assessmentMain = angular.element('section#assessment-main');
        if (assessmentMain && assessmentMain[0]) {
          assessmentMain[0].focus();
        }
      }, 500);
    }
  }
})();